import { graphql } from '@apollo/react-hoc';
import gql from 'graphql-tag';
import SubscriptionUpgradeForm from './subscription-upgrade-form';
import { SimpleLoadingComponent } from '../../utils/apollo';

export const userInfoQuery = gql`
  query SubscriptionUpgradeFormComponent {
    viewer {
      id
      firstName
      lastName
      uuid
      email
      enabledFeatures
      institution {
        id
        name
        field_country
        field_state_short_name
      }
    }
  }
`;

export default SimpleLoadingComponent(graphql(userInfoQuery))(SubscriptionUpgradeForm);
